import { Route, Redirect } from 'react-router-dom'
import AdminAuth from './admin/AdminAuth'

const AdminRoute = ({ component: Component, redirect, ...rest }: any) => {
  return (
    <Route
      {...rest}
      render={(props: any) => {
        if (AdminAuth()) {
          return <Component {...props} />
        } else {
          return <Redirect to={redirect} />
        }
      }}
    />
  )
}

export default AdminRoute
